import BaseValue, { SetPropertyActionValue } from './BaseValue'

export default class CalculateValue extends BaseValue {
  declare type: SetPropertyActionValue.Calculate
  value!: string
}
